import styled from "styled-components";
import { Container, Paper, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { UserRole } from "src/types";
import { useUserCreateMutation } from "src/hooks/users";
import { UserForm, UserFormData } from "src/forms/UserForm";
import { PageHeader } from "src/components/page/PageHeader";

interface Props {
  onClose: () => void;
}

export function UserCreatePage(props: Props) {
  const { t } = useTranslation();
  const createMutation = useUserCreateMutation();

  /**
   * Functions
   */
  async function handleSave(values: UserFormData) {
    await createMutation.mutateAsync(values);
    props.onClose();
  }

  return render();

  function render() {
    return (
      <StyledContainer maxWidth="lg">
        <Paper>
          <PageHeader>
            <Typography variant="h3" noWrap className="page-title">
              {t("label.addNewUser")}
            </Typography>
          </PageHeader>
          <UserForm
            data={{
              firstName: "",
              lastName: "",
              email: "",
              role: UserRole.EXPERT,
              enabled: false,
            }}
            onClose={() => props.onClose()}
            onSubmit={handleSave}
            isLoading={createMutation.isLoading}
            errors={createMutation.error?.response?.data}
          />
        </Paper>
      </StyledContainer>
    );
  }
}

const StyledContainer = styled(Container)`
  .MuiPaper-root {
    padding: ${({ theme }) => theme.spacing(3)};
  }
`;
